var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{class:_vm.fixCenter ? 'cool-skeleton-fullheight' : ''},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cool-skeleton-icon"},[_c('div',{staticClass:"cool-skeleton-ufo"}),_c('div',{staticClass:"cool-skeleton-shadow"})])
}]

export { render, staticRenderFns }